import {
  IconUser,
  IconReportSearch,
  IconFileCv
} from '@tabler/icons-react';

const icons = {
  IconUser,
  IconReportSearch,
  IconFileCv,
};

const dashboard = {
  id: 'dashboard',
  title: '',
  type: 'group',
  children: [
    {
      id: 'candidate-profile',
      title: 'Profile',
      type: 'item',
      url: '/candidate-profile',
      icon: icons.IconUser,
      breadcrumbs: false
    },
    {
      id: 'jobs',
      title: 'Jobs',
      type: 'item',
      url: '/jobs',
      icon: icons.IconReportSearch,
      breadcrumbs: false
    },
    {
      id: 'applied-jobs',
      title: 'Applied Jobs',
      type: 'item',
      url: '/applied-jobs',
      icon: icons.IconFileCv,
      breadcrumbs: false
    },
  ]
};

export default dashboard;
